import { render, staticRenderFns } from "./class-stats-list.vue?vue&type=template&id=56a2ed26&scoped=true"
import script from "./class-stats-list.vue?vue&type=script&lang=js"
export * from "./class-stats-list.vue?vue&type=script&lang=js"
import style0 from "./class-stats-list.vue?vue&type=style&index=0&id=56a2ed26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2ed26",
  null
  
)

export default component.exports